module.exports = __webpack_public_path__ + "static/img/result_ls_lens_up_angle.978b85c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_lens_up_angle.jpg
// module id = za1x
// module chunks = 3